import { Get, Post, Put, Delete } from '../../api/axiosCoreConfig';

export const getAllFormStructure = async (namespace) =>
    await Get(`/form/structure?namespace=${namespace}`);
export const getFormStructure = async (formType, namespace) =>
    await Get(`/form/structure/${formType}?namespace=${namespace}`);
export const createForm = async (formType, form) => await Post(`/form/instance/${formType}`, form);
export const getPatientForms = async (patientId, formType) =>
    await Get(`/form/instance/${formType}?patient_id=${patientId}`);
export const getFormDetail = async (formId) => await Get(`/form/instance/${formId}`);
export const editForm = async (formId, form) => await Put(`/form/instance/${formId}`, form);
export const deleteForm = async (formId) => await Delete(`/form/instance/${formId}`);
